//interfaces
import React from "react";

//interfaces
import { Direction, IDirectionalToggle } from "../../../../interfaces/toggles/IToggle";
import { SimpleSortBy } from "../../../../interfaces/tables/ISimpleTable";
import { toggleIcon } from "../../../../helpers/Toggle";


const UseDirectionalToggle = ({
    direction, 
    sortAscending, 
    sortDescending, 
    defaultSort, 
    onRemoveDefaultSort, 
    ascendingLabel, 
    descendingLabel
}:IDirectionalToggle ) => {

    const directionOrDefault = () => {
        if (defaultSort && !direction) {
            return defaultSort === SimpleSortBy.ASCENDING ? Direction.UP : Direction.DOWN
        } else if (!defaultSort && !direction) {
            return Direction.BOTH
        } else {
            return direction
        }
    }

    const handleClick = () => {
        onRemoveDefaultSort?.();
        
        if (directionOrDefault() === Direction.DOWN) {
            sortAscending();
        } else {
            sortDescending();
        }
    };

    const getAriaLabel = () => {
        if (directionOrDefault() === Direction.DOWN) {
            return ascendingLabel ?? "Sort ascending";
        } else {
            return descendingLabel ?? "Sort descending";
        }
    };

    const getToggleIcon = () => {
        return toggleIcon(directionOrDefault());
    };

    return { handleClick, getAriaLabel, getToggleIcon };
};

export default UseDirectionalToggle;